export class Combo
{
    public OrderID:string = '';
    public ID:string = '';
    public UniversalID:string = '';
    public Tags:string[] = new Array();
    public Show:boolean = true;
    public ShowDay:boolean[] = new Array( true, true, true, true, true, true, true );
    public Display:number = -1;

    public Icon:string = 'assets/img/placeholder.png';
    public Picture:string = 'assets/img/placeholder.png';
    public Name:string = '';
    public Description:string = '';
    public NotDismantable:boolean = false;

    public ComboCount:number = 1;
    public OriginalPrice:number = 0.0;
    public DefaultPrice:number = 0.0;

    public PrintName:string = '';
    public NameAppend:string = '';

    public Number:number = 0;
    public Timestamp:number = 0;
    public Removed:boolean = false;
    public OutOfStock:boolean = false;

    public ItemCount:number = 0;

    public ItemGroupsList:Array<ComboItemGroupModel> = [];

    setData(data:any)
    {
        if(data.ItemGroupsList !== null && data.ItemGroupsList !== undefined)
        {   
            this.ItemGroupsList = new Array<ComboItemGroupModel>();

            for (const key in data.ItemGroupsList) 
            {
                if (Object.prototype.hasOwnProperty.call(data.ItemGroupsList, key)) 
                {
                    const itemGroup = data.ItemGroupsList[key];
                    
                    var newItemGroup = new ComboItemGroupModel();

                    Object.assign(newItemGroup, itemGroup);

                    newItemGroup.setData(itemGroup);

                    this.ItemGroupsList.push(newItemGroup);
                }
            }
        }
    }
}

export class ComboItemGroupModel
{
    public ID:string = '';
    public Name:string = '';
    public Description:string = '';
    public ItemName:string = '';
    public ItemSummary:string = '';
    public Priority:number = 0;
    public CurrentItem:string = '';
    public ItemPresetList:Array<ItemPreset> = [];
    public IsEmpty = false;
    public AllowEmpty = false;

    public IsOptionalOkay:boolean = false;

    public get ShowWarning()
    {
        return !this.IsOptionalOkay || this.CurrentItem.length === 0;
    }

    public get ShowName()
    {
        if (this.CurrentItem.length === 0 || this.IsEmpty)
            return this.Name;
        else
            return this.ItemName;
    }

    public get Summary()
    {
        if(this.IsEmpty)
            return "Nenhum";
        if (this.CurrentItem.length === 0)
            return this.Description;
        else
            return this.ItemSummary;
    }

    setData(data:any)
    {
        if(data.ItemPresetList !== null && data.ItemPresetList !== undefined)
        {
            this.ItemPresetList = new Array<ItemPreset>();

            for (const key in data.ItemPresetList) 
            {
                if (Object.prototype.hasOwnProperty.call(data.ItemPresetList, key)) 
                {
                    const itemPreset = data.ItemPresetList[key];
                    
                    var newItemPreset = new ItemPreset();

                    Object.assign(newItemPreset, itemPreset);

                    this.ItemPresetList.push(newItemPreset);
                }
            }
        }
    }
}

export class ItemPreset
{
    public ItemUniversalID:string = '';
    public Count:number = 0;
    public Priority:number = 0;
    public OriginalPrice = 0;
    public Price = 0;

    public Name:string = '';
    public Description:string = '';
    public Picture:string = '';
}
